    <p-multiSelect
        (onChange)="changeResolutionCode($event)"
        [options]="resCodeOptions"
        optionValue="value"
        [(ngModel)]="filter.resCode"
        [filter]="true"
        class="multiSelectStyle">   
    </p-multiSelect>